export const brandConfigObjectMap = new Map();

brandConfigObjectMap.set("blg-singtel-en", {
  language: "en",
  country: "SG",
  price: "S$7.99 per week",
  gameUrl: "https://sg.blg.gg",
  platformUrl: "https://sg.blg.gg",
  subscribeFlowUrl: "http://sg-play.blg.gg",
  heroTagline: "The Ultimate Mobile Gaming Arena.",
  headerText: "Play competitive gaming anytime, anywhere and climb the ranks!",
  // subHeaderText:
  //   "Subscribe now, and challenge your opponents with only 7.99 SGD Weekly. Enjoy a 3-day free trial for your first Registration",
  errorText: "An error has occurred, please click retry below.",
  subscribeButton: "SUBSCRIBE NOW",
  phoneNumberPrompt: "Enter your mobile number",
  phoneNumberEmptyText: "Enter your mobile number to continue.",
  phoneNumberInvalidText: "Please enter a valid 8-digit Singapore mobile number starting with 8 or 9.",
  termsAndConditionsText: "Terms and Conditions",
  termsAndConditionsUrl: "https://sg.blg.gg/terms-conditions",
  unsubscribeLinkText: "Unsubscribe",
  unsubscribeEmptyText: "Enter your mobile number above to unsubscribe.",
  unsubscribeSuccessText: "You have been unsubscribed.",
  unsubscribeNotFoundText: "No active subscription was found for this number.",
  tabTitle: "Battle League Gaming",
  landingPage: "LandingPageBLG",
  battlegroundsLabel: "All Our Battlegrounds",
  unsubHelpText: "To unsubscribe,send STOP to 8761.For help +65 8008528393",
  serviceId: '309',
  productId: '317',
  networkServiceId: 'SG050008',
  subscriptionDisclosure:
    "Welcome to the Battle League Gaming. Browse our most popular games here. This is a subscription service that costs SGD7.99 per 7 days (VAT included). This subscription will automatically renew weekly. Amount will be added to the next Singtel Bill. By registering on the site, you confirm that you have read and agree to the Terms and Conditions and Privacy Policy, that you are at least 18 years old and that you are the owner of the phone number used for registration. This content is only available to Singtel users. Service provided by: Penrose Systems. You can contact us by email at blg.sg@silverlines.info or by phone: +65 8008528393. To cancel, unsubscribe from the portal.",
});
